import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./ServiceStatusBanner.scss";

/** Toggle to false when the incident is resolved. */
export const SHOW_SERVICE_STATUS_BANNER = false;

const BODY_CLASS = "has-service-status-banner";
const HEIGHT_VAR = "--service-status-banner-height";

const ServiceStatusBanner = () => {
  const { t } = useTranslation("common");
  const bannerRef = useRef(null);

  useEffect(() => {
    if (!SHOW_SERVICE_STATUS_BANNER) {
      return undefined;
    }

    const root = document.documentElement;
    const body = document.body;
    body.classList.add(BODY_CLASS);

    const updateHeight = () => {
      const height = bannerRef.current?.offsetHeight || 0;
      root.style.setProperty(HEIGHT_VAR, `${height}px`);
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      body.classList.remove(BODY_CLASS);
      root.style.removeProperty(HEIGHT_VAR);
    };
  }, []);

  if (!SHOW_SERVICE_STATUS_BANNER) {
    return null;
  }

  return (
    <div
      ref={bannerRef}
      className="service-status-banner"
      role="alert"
      aria-live="polite"
    >
      {t("global.service_status_banner")}
    </div>
  );
};

export default ServiceStatusBanner;
